import React, { useCallback, useEffect, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { TextFieldCustom, useStyles } from './styles';
import { Field, Form, Formik, useFormikContext } from 'formik';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { themeButtons } from '../../css/themeButtons';
import YmapsContainer from '../common/YandexMap/YmapsContainer';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { usePrevious } from '../common/CustomHook/usePrevious';
import { createFilterOptions } from '@material-ui/lab';
import * as Yup from 'yup';
import FormHelperText from '@material-ui/core/FormHelperText';
import { debounce } from 'lodash';
import { Redirect } from 'react-router-dom';

const filterOptions = createFilterOptions({
  matchFrom: 'start',
});

const RenderAddFrom = ({
  objectTypes,
  countries,
  getCities,
  cities,
  addresses,
  geoCode,
  mapTarget,
}) => {
  const { setFieldValue, setValues, values, errors, touched, isSubmitting } =
    useFormikContext();
  const [geoCodeStatus, setGeoCodeStatus] = useState(false);

  let countryValue = values.country;
  let addressValue = values.address;
  let typeValue = values.type;
  const prevCountry = usePrevious(countryValue);

  const setFloorCondition =
    // typeValue === '19347' || // этаж под ключ
    typeValue === '19340' || // квартира
    // typeValue === '19341' || // апартаменты
    typeValue === '19346'; // комната в квартире

  const getGeoObject = (country, formValue) => {
    if (
      country &&
      formValue.cityName &&
      formValue.address &&
      formValue.address.length > 2
    ) {
      geoCode(
        country +
        `, ` +
        formValue.cityName.split(', ').reverse().join(', ') +
        `, ` +
        formValue.address
      );
    }
  };

  const delayedQuery = useCallback(
    debounce((country, values) => getGeoObject(country, values), 700),
    []
  );

  useEffect(() => {
    if (geoCodeStatus) {
      setGeoCodeStatus(false);
      return;
    }
    if (countryValue && countryValue != prevCountry) {
      getCities(countryValue);
    }

    if (addressValue && addressValue.length !== 0) {
      delayedQuery(countries[values.country].label, values);
    }
  }, [values]);

  const classes = useStyles();
  const buttons = themeButtons();
  return (
    <div className='row g-3'>
      <div className='col-xl-12'>
        <Field name='type'>
          {({ field }) => (
            <FormControl
              variant='outlined'
              size='small'
              fullWidth
              error={Boolean(errors.type && touched.type)}
            >
              <InputLabel>Тип объекта</InputLabel>
              <Select
                {...field}
                label='Тип номера'
                MenuProps={{ classes: { paper: classes.menuPaper } }}
              >
                {objectTypes &&
                  Object.keys(objectTypes).map((item) => {
                    return (
                      <MenuItem
                        key={item}
                        className='justify-content-center'
                        value={item}
                      >
                        {objectTypes[item]}
                      </MenuItem>
                    );
                  })}
              </Select>

              {errors.type && touched.type ? (
                <FormHelperText>
                  {errors.type && touched.type && String(errors.type)}
                </FormHelperText>
              ) : null}
            </FormControl>
          )}
        </Field>
      </div>
      {!setFloorCondition && (
        <div className='col-xl-12'>
          <Field
            validate={(value) => {
              if (!value) {
                return 'Поле не заполнено';
              }
              if (value < 0) {
                return 'Значение не должно быть отрицательным';
              }
            }}
            name='roomsCount'
          >
            {({ field, form }) => {
              return (
                <TextField
                  {...field}
                  type='number'
                  label='Количество номеров'
                  fullWidth
                  size='small'
                  variant='outlined'
                  inputProps={{
                    autoComplete: 'new-password',
                    form: {
                      autoComplete: 'new-password',
                    },
                  }}
                  error={Boolean(errors.roomsCount && touched.roomsCount)}
                  helperText={
                    errors.roomsCount && touched.roomsCount && errors.roomsCount
                  }
                />
              );
            }}
          </Field>
        </div>
      )}
      {setFloorCondition && (
        <div className='col-xl-6'>
          <Field
            name='floorValue'
            validate={(value) => {
              if (!value) {
                return 'Поле не заполнено';
              }
              if (value < 0) {
                return 'Значение не должно быть отрицательным';
              }
            }}
          >
            {({ field, form }) => (
              <TextField
                {...field}
                type='number'
                label='Этаж'
                fullWidth
                size='small'
                variant='outlined'
                inputProps={{
                  autoComplete: 'new-password',
                  form: {
                    autoComplete: 'new-password',
                  },
                }}
                error={Boolean(errors.floorValue && touched.floorValue)}
                helperText={
                  errors.floorValue && touched.floorValue && errors.floorValue
                }
              />
            )}
          </Field>
        </div>
      )}
      {setFloorCondition && (
        <div className='col-xl-6'>
          <Field
            name='floorTotalCount'
            validate={(value) => {
              if (!value) {
                return 'Поле не заполнено';
              }
              if (value < 0) {
                return 'Значение не должно быть отрицательным';
              }
            }}
          >
            {({ field, form }) => (
              <TextField
                {...field}
                label='Всего этажей'
                type='number'
                fullWidth
                size='small'
                variant='outlined'
                inputProps={{
                  autoComplete: 'new-password',
                  form: {
                    autoComplete: 'new-password',
                  },
                }}
                error={Boolean(
                  errors.floorTotalCount && touched.floorTotalCount
                )}
                helperText={
                  errors.floorTotalCount &&
                  touched.floorTotalCount &&
                  errors.floorTotalCount
                }
              />
            )}
          </Field>
        </div>
      )}
      <div className='col-xl-12'>
        <Field name='name'>
          {({ field, form }) => (
            <TextField
              {...field}
              label='Название'
              fullWidth
              size='small'
              variant='outlined'
              inputProps={{
                autoComplete: 'new-password',
                form: {
                  autoComplete: 'new-password',
                },
              }}
              error={Boolean(errors.name && touched.name)}
              helperText={errors.name && touched.name && String(errors.name)}
            />
          )}
        </Field>
      </div>
      <div className='col-xl-6'>
        <Field name='country'>
          {({ field }) => (
            <FormControl
              variant='outlined'
              size='small'
              fullWidth
              error={Boolean(errors.country && touched.country)}
            >
              <InputLabel>Страна</InputLabel>
              <Select
                {...field}
                label='Страна'
                MenuProps={{ classes: { paper: classes.menuPaper } }}
              >
                {countries &&
                  Object.keys(countries).map((country) => {
                    return (
                      <MenuItem
                        key={country}
                        className='justify-content-center'
                        value={country}
                      >
                        {countries[country].label}
                      </MenuItem>
                    );
                  })}
              </Select>

              {errors.country && touched.country ? (
                <FormHelperText>
                  {errors.country && touched.country && String(errors.country)}
                </FormHelperText>
              ) : null}
            </FormControl>
          )}
        </Field>
      </div>
      <div className='col-xl-6'>
        <Field name='cityName'>
          {({ field, form }) => (
            <Autocomplete
              freeSolo
              disabled={cities ? false : true}
              filterOptions={filterOptions}
              options={
                cities
                  ? Object.keys(cities).map((option) => cities[option])
                  : []
              }
              onChange={(e, value) => setFieldValue('cityName', value || '')}
              onInputChange={(e, value) =>
                setFieldValue('cityName', value || '')
              }
              renderInput={(params) => (
                <TextFieldCustom
                  {...params}
                  label='Город'
                  fullWidth
                  size='small'
                  variant='outlined'
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'new-password',
                  }}
                  error={Boolean(errors.cityName && touched.cityName)}
                  helperText={
                    errors.cityName &&
                    touched.cityName &&
                    String(errors.cityName)
                  }
                />
              )}
            />
          )}
        </Field>
      </div>
      <div className='col-xl-12'>
        <Field name='address'>
          {({ field, form }) => (
            <Autocomplete
              freeSolo
              includeInputInList
              disabled={values.cityName ? false : true}
              options={
                addresses
                  ? Object.keys(addresses).map(
                    (option) => addresses[option].address
                  )
                  : []
              }
              onChange={(e, value) => {
                value && geoCode(value);
                setGeoCodeStatus(true);
                setFieldValue('address', value || '');
              }}
              onInputChange={(e, value) =>
                setFieldValue('address', value || '')
              }
              filterOptions={(options, state) => {
                return options;
              }}
              renderInput={(params) => (
                <TextFieldCustom
                  {...params}
                  label='Адрес'
                  fullWidth
                  size='small'
                  variant='outlined'
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'new-password',
                  }}
                  error={Boolean(errors.address && touched.address)}
                  helperText={
                    errors.address && touched.address && String(errors.address)
                  }
                />
              )}
            />
          )}
        </Field>
      </div>

      <div className='col-auto mx-auto mt-4'>
        <Button
          type='submit'
          disabled={isSubmitting || !mapTarget}
          className={`btn ${buttons.btnGreen}`}
        >
          Добавить объект
        </Button>
      </div>
    </div>
  );
};

const ObjectAddNew = (props) => {
  const {
    getTypes,
    getCountries,
    getCities,
    objectTypes,
    countries,
    cities,
    geoCode,
    addresses,
    addObject,
    newObjectId,
    email,
    personalMobile,
    verified,
  } = props;

  const [mapTarget, setMapTarget] = useState();

  const newObject = Yup.object().shape({
    name: Yup.string()
      .matches(/\S/, 'Поле не заполнено')
      .required('Поле не заполнено'),
    type: Yup.string().required('Поле не заполнено'),
    country: Yup.string()
      .matches(/\S/, 'Поле не заполнено')
      .required('Поле не заполнено'),
    cityName: Yup.string()
      .matches(/\S/, 'Поле не заполнено')
      .required('Поле не заполнено'),
    address: Yup.string()
      .matches(/\S/, 'Поле не заполнено')
      .min(3, 'Слишком короткий адрес')
      .required('Поле не заполнено'),
  });

  //предупреждения (аккаунт не подтвержден, емаил не подтвержден)
  const [alerts, setAlerts] = useState({
    verified: false,
    email: false,
    personalMobile: false,
  });

  useEffect(() => {
    setAlerts((prev) => {
      return {
        ...prev,
        email: email ? email : false,
        personalMobile: personalMobile ? personalMobile : false,
        verified: verified ? verified : false,
      };
    });
  }, [email, personalMobile, verified]);

  useEffect(() => {
    getTypes();
    getCountries();
  }, []);

  const lastFirstPosition = usePrevious(
    addresses && addresses[0].position.split(' ').reverse()
  );
  useEffect(() => {
    if (addresses && addresses[0]) {
      setMapTarget(
        addresses[0].position
          ? addresses[0].position.split(' ').reverse()
          : lastFirstPosition
      );
    }
  }, [addresses]);

  const onSubmit = (values) => {
    let city = Object.keys(cities).find(
      (city) => cities[city] === values.cityName
    );

    let newObject = {
      ...values,
      city: city ? city : '',
      coordinates: mapTarget.join(', '),
    };
    if (newObject.floorValue) {
      newObject.roomsCount = '1';
    }


    addObject(newObject);
  };

  const updateMapTarget = (target) => {
    setMapTarget(target);
  };

  //закрытие предупреждений
  const closeAlert = (alert) => {
    setAlerts({ ...alerts, [alert]: true });
  };

  const alertInfo = {
    verified: {
      title: 'Аккаунт не подтвержден.',
      text: 'Подтвердите аккаунт для дальнейшего подтверждения договора',
    },
    email: {
      title: 'Не заполнено поле Email в профиле.',
      text: 'Добавьте Email что-бы не пропустить ни одного уведомления',
    },
    personalMobile: {
      title: 'Не заполнено поле телефон в профиле.',
      text: 'Добавьте телефон что-бы не пропустить ни одного уведомления',
    },
  };

  if (newObjectId) {
    return <Redirect to={`/lk/${newObjectId}`}/>;
  }
  return (
    <div className='main'>
      <div className='container-fluid'>
        <div className='add-object'>
          <div className='row'>
            <div className='col-12'>
              {alerts &&
                Object.keys(alerts).map(
                  (alert) =>
                    !alerts[alert] && (
                      <div
                        key={alert}
                        className='alert alert-warning alert-dismiss'
                      >
                        <span>
                          {' '}
                          <strong>{alertInfo[alert].title} </strong>
                          {alertInfo[alert].text}
                        </span>
                        <IconButton
                          onClick={() => closeAlert(alert)}
                          className='alert-dismiss__btn'
                        >
                          <CloseRoundedIcon/>
                        </IconButton>
                      </div>
                    )
                )}

              <h4 className='mb-3'>Добавление нового объекта</h4>
              <div className='d-flex flex-column-reverse flex-lg-row'>
                <div className='add-object__block pe-lg-2'>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      type: '',
                      floorValue: '',
                      floorTotalCount: '',
                      roomsCount: '',
                      name: '',
                      country: '',
                      cityName: '',
                      address: '',
                    }}
                    validationSchema={newObject}
                    onSubmit={onSubmit}
                  >
                    {({ values, handleSubmit, errors }) => (
                      <Form>
                        <RenderAddFrom
                          onSubmit={handleSubmit}
                          objectTypes={objectTypes}
                          countries={countries}
                          getCities={getCities}
                          cities={cities}
                          addresses={addresses}
                          geoCode={geoCode}
                          mapTarget={mapTarget}
                        />
                      </Form>
                    )}
                  </Formik>
                </div>

                <div className='add-object__block mb-3 ps-lg-2'>
                  <YmapsContainer
                    mapTarget={mapTarget}
                    updateMapTarget={updateMapTarget}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObjectAddNew;
